export default {
  default: () => import("/opt/buildhome/repo/layouts/default.vue")
}